import { makeStyles } from '@material-ui/core'
import { loginBackground } from 'src/assets/png'

export const useStyles = makeStyles((theme) => ({
  confirmationsWrapper: {
    width: '100%',
    height: '100vh',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: theme.app.spacing.base,
    alignItems: 'stretch',
    color: '#FFF',
    background: `linear-gradient(0deg, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), ${theme.palette.primary.main}`,
    padding: 0,
    overflow: 'hidden',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      gap: 0,
      justifyContent: 'center',
      alignItems: 'center',
      background: '#301e1a'
    }
  },

  confirmationsForm: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
    padding: '40px 60px',
    gap: theme.app.spacing.xl,
    flex: 1,
    minWidth: 0,
    maxWidth: 732,
    height: '100vh',
    overflow: 'auto',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      maxWidth: 'unset',
      padding: 30,
      gap: theme.app.spacing.xl,
      height: 'auto'
    }
  },

  confirmationsImageSide: {
    width: 708,
    height: '100vh',
    backgroundImage: `linear-gradient(0deg, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(${loginBackground})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    [theme.breakpoints.down('md')]: {
      display: 'none'
    }
  },

  confirmationsTitleWrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    width: '100%',
    maxWidth: 532,
    '& h1': {
      fontFamily: theme.app.typography.fontFamily.main,
      fontStyle: 'normal',
      fontWeight: 900,
      fontSize: 28,
      lineHeight: '150%',
      color: theme.app.colors.text.light,
      margin: 0
    }
  },

  confirmationsInfoWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.app.spacing.md,
    width: '100%',
    maxWidth: 532,
    '& h2': {
      fontFamily: theme.app.typography.fontFamily.main,
      fontStyle: 'normal',
      fontWeight: 700,
      fontSize: theme.app.typography.h2.fontSize,
      lineHeight: '150%',
      color: theme.app.colors.text.light,
      margin: 0,
      width: '100%'
    }
  },

  confirmationsDescription: {
    fontFamily: theme.app.typography.fontFamily.main,
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: 15,
    lineHeight: '150%',
    color: 'rgba(250, 250, 250, 0.85)',
    margin: 0
  },

  confirmationsSuccessBox: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.app.spacing.base,
    padding: '20px 24px',
    backgroundColor: 'rgba(76, 175, 80, 0.15)',
    border: '2px solid #4caf50',
    borderRadius: theme.app.borderRadius.md,
    width: '100%',
    maxWidth: 532,
    '& p': {
      fontFamily: theme.app.typography.fontFamily.main,
      fontSize: 15,
      fontWeight: 500,
      color: '#4caf50',
      margin: 0
    }
  },

  confirmationsSuccessIcon: {
    color: '#4caf50',
    fontSize: 32
  },

  confirmationsSelection: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.app.spacing.base,
    width: '100%',
    maxWidth: 532
  },

  confirmationsVerificationCard: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 20,
    padding: '20px 24px',
    width: '100%',
    background: theme.app.colors.input.backgroundMuted,
    border: '2px solid rgba(222, 161, 105, 0.3)',
    borderRadius: theme.app.borderRadius.lg,
    cursor: 'pointer',
    transition: 'all 0.3s',
    textAlign: 'left',
    '&:hover': {
      background: theme.app.colors.input.background,
      borderColor: '#dea169',
      transform: 'translateY(-2px)'
    },
    '&:active': {
      transform: 'translateY(0)'
    },
    '&:disabled': {
      cursor: 'not-allowed',
      opacity: 0.6,
      '&:hover': {
        background: theme.app.colors.input.backgroundMuted,
        borderColor: 'rgba(222, 161, 105, 0.3)',
        transform: 'none'
      }
    }
  },

  confirmationsVerificationCardValidated: {
    background: 'rgba(76, 175, 80, 0.15) !important',
    border: '2px solid rgba(76, 175, 80, 0.5) !important',
    cursor: 'not-allowed !important',
    '&:hover': {
      background: 'rgba(76, 175, 80, 0.15) !important',
      borderColor: 'rgba(76, 175, 80, 0.5) !important',
      transform: 'none !important'
    }
  },

  confirmationsCardIcon: {
    width: 48,
    height: 48,
    borderRadius: '50%',
    backgroundColor: 'rgba(120, 74, 66, 0.3)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    '& svg': {
      color: '#dea169',
      fontSize: theme.app.typography.h2.fontSize
    }
  },

  confirmationsCardContent: {
    flex: 1,
    '& h3': {
      fontFamily: theme.app.typography.fontFamily.main,
      fontStyle: 'normal',
      fontWeight: 600,
      fontSize: theme.app.typography.body.fontSize,
      lineHeight: '150%',
      color: theme.app.colors.text.light,
      margin: '0 0 4px 0'
    },
    '& p': {
      fontFamily: theme.app.typography.fontFamily.main,
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: theme.app.typography.paragraph.fontSize,
      lineHeight: '150%',
      color: 'rgba(250, 250, 250, 0.7)',
      margin: 0
    }
  },

  confirmationsSkipButton: {
    height: 56,
    fontSize: theme.app.typography.body.fontSize,
    fontWeight: 500,
    color: theme.palette.primary.main,
    width: '100%',
    border: `2px solid ${theme.palette.primary.main}`,
    backgroundColor: 'transparent',
    boxShadow: '0px 2px 8px rgba(120, 74, 66, 0.15)',
    borderRadius: theme.app.borderRadius.lg,
    cursor: 'pointer',
    textAlign: 'center',
    transition: 'all 0.2s',
    fontFamily: theme.app.typography.fontFamily.main,
    marginTop: theme.app.spacing.sm,
    '&:hover': {
      backgroundColor: 'rgba(120, 74, 66, 0.1)'
    }
  },

  // Old styles kept for backwards compatibility with modal components
  confirmationsButton: {
    width: '100%',
    marginBottom: theme.app.spacing.base,
    height: 48
  },

  confirmationsIgnoreButton: {
    backgroundColor: theme.palette.text.primary,
    color: theme.palette.primary.main,
    border: `2px solid ${theme.palette.primary.main}`,
    width: '100%',
    marginBottom: theme.app.spacing.base,
    height: 48
  },

  confirmationsButtonContainer: {
    display: 'block',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    '& button': {
      margin: '0 16px 0 0'
    },
    '& .confirmations__button-ignore': {
      width: '100%',
      backgroundColor: theme.palette.text.primary,
      color: theme.palette.primary.main,
      border: `2px solid ${theme.palette.primary.main}`
    },
    '& .confirmations__button-save': {
      width: '100%',
      marginTop: theme.app.spacing.base
    },
    [theme.breakpoints.up('sm')]: {
      display: 'flex'
    }
  }
}))
